document.addEventListener('DOMContentLoaded', function() {
  const reviewsSliderElement = document.querySelector('.landing-page-reviews__slider');
  
  if (reviewsSliderElement) {
    const sectionElement = reviewsSliderElement.closest('.landing-page-reviews');
    const enableLoop = sectionElement.dataset.enableLoop === 'true';
    const enableAutoplay = sectionElement.dataset.enableAutoplay === 'true';
    const autoplayDelay = parseInt(sectionElement.dataset.autoplayDelay) || 4000;
    const slidesPerView = parseInt(sectionElement.dataset.slidesPerView) || 3;
    const hidePagination = sectionElement.dataset.hidePagination === 'true';
    const templateSuffix = sectionElement.dataset.templateSuffix || '';

    const customSlidesPerViewTemplates = ['lp-flosser-bad-breath', 'lp-flosser-gum-disease'];
    const useCustomSlidesPerView = customSlidesPerViewTemplates.includes(templateSuffix);

    function getActualSlidesCount() {
      return reviewsSliderElement.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    }

    function getOptimalSlidesPerView(screenWidth, totalSlides, desktopSlidesPerView) {
      let optimalSlides;
      
      if (screenWidth >= 1024) {
        if (useCustomSlidesPerView) {
          optimalSlides = Math.min(desktopSlidesPerView, totalSlides);
        } else {
          if (screenWidth >= 1280) {
            optimalSlides = Math.min(4, totalSlides);
          } else {
            optimalSlides = Math.min(3, totalSlides);
          }
        }
      } else if (screenWidth >= 768) {
        optimalSlides = Math.min(2, totalSlides);
      } else {
        optimalSlides = 1;
      }
      
      return optimalSlides;
    }

    const actualSlidesCount = getActualSlidesCount();
    const screenWidth = window.innerWidth;
    const shouldEnableLoop = enableLoop && actualSlidesCount > getOptimalSlidesPerView(screenWidth, actualSlidesCount, slidesPerView);

    if (useCustomSlidesPerView && screenWidth >= 1024) {
      const spaceBetween = screenWidth >= 1440 ? 40 : screenWidth >= 1280 ? 32 : 24;
      sectionElement.style.setProperty('--space-between', spaceBetween + 'px');
    }

    const reviewsSlider = new Swiper('.landing-page-reviews__slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: shouldEnableLoop,
      grabCursor: true,
      allowTouchMove: true,
      speed: 600,
      effect: 'slide',
      
      watchOverflow: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      
      autoplay: enableAutoplay && shouldEnableLoop ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      
      pagination: hidePagination ? false : {
        el: '.landing-page-reviews__slider-pagination',
        clickable: true,
        type: 'bullets',
        dynamicBullets: false,
      },
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      breakpoints: {
        320: {
          slidesPerView: Math.min(1, actualSlidesCount),
          spaceBetween: 10,
          centeredSlides: actualSlidesCount === 1,
        },
        768: {
          slidesPerView: Math.min(2, actualSlidesCount),
          spaceBetween: 20,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: useCustomSlidesPerView 
            ? Math.min(slidesPerView, actualSlidesCount)
            : Math.min(3, actualSlidesCount),
          spaceBetween: 24,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: useCustomSlidesPerView 
            ? Math.min(slidesPerView, actualSlidesCount)
            : Math.min(4, actualSlidesCount),
          spaceBetween: 32,
          centeredSlides: false,
        },
        1440: {
          slidesPerView: useCustomSlidesPerView 
            ? Math.min(slidesPerView, actualSlidesCount)
            : Math.min(4, actualSlidesCount),
          spaceBetween: 40,
          centeredSlides: false,
        }
      },
      
      on: {
        init: function() {
          setTimeout(() => {
            this.updateSize();
            this.updateSlidesClasses();
            this.update();
          }, 100);
        },
        
        resize: function() {
          const newScreenWidth = window.innerWidth;
          const newOptimalSlides = getOptimalSlidesPerView(newScreenWidth, actualSlidesCount, slidesPerView);
          
          if (useCustomSlidesPerView && newScreenWidth >= 1024) {
            const spaceBetween = newScreenWidth >= 1440 ? 40 : newScreenWidth >= 1280 ? 32 : 24;
            sectionElement.style.setProperty('--space-between', spaceBetween + 'px');
          }
          
          if (actualSlidesCount <= newOptimalSlides) {
            this.loopDestroy();
          } else if (enableLoop && !this.loopedSlides) {
            this.loopCreate();
          }
          
          this.updateSize();
          this.updateSlidesClasses();
          this.update();
        },
        
        beforeDestroy: function() {
          if (this.autoplay) {
            this.autoplay.stop();
          }
        },
        
        slideChangeTransitionEnd: function() {
          if (this.activeIndex >= actualSlidesCount && !this.params.loop) {
            this.slideTo(actualSlidesCount - 1, 0);
          }
        }
      }
    });

    let resizeTimer;
    let lastWidth = window.innerWidth;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const currentWidth = window.innerWidth;
        
        if (Math.abs(currentWidth - lastWidth) > 50 && reviewsSlider && !reviewsSlider.destroyed) {
          lastWidth = currentWidth;
          
          const currentSlide = reviewsSlider.realIndex || 0;
          
          reviewsSlider.update();
          
          setTimeout(() => {
            if (currentSlide < actualSlidesCount) {
              reviewsSlider.slideTo(currentSlide, 0);
            }
          }, 50);
        }
      }, 300);
    });

    setTimeout(() => {
      if (reviewsSlider && !reviewsSlider.destroyed) {
        reviewsSlider.update();
      }
    }, 1000);
  }
});